var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("AppBadge")]),_c('table',[_c('tr',[_c('th',[_c('AppBadge',{attrs:{"text":"Disponible","color":"#039855"}})],1),_c('th',[_c('AppBadge',{attrs:{"text":"Reservado","color":"#DC6803"}})],1),_c('th',[_c('AppBadge',{attrs:{"text":"Vendido","color":"#D92D20"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }